(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rose-cookie-flavors"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rose-cookie-mix]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    const inputs = [...root.querySelectorAll('[data-flavor-count]')];
    const selected = root.querySelector('[data-selected-total]');
    const box = root.querySelector('[data-box-size]');
    const error = root.querySelector('[data-error]');
    const getSize = () => {
      const id = form.querySelector('input[name="id"]')?.value;
      const record = [...root.querySelectorAll('[data-variant-id]')].find(el => el.dataset.variantId === id);
      return Number(record?.dataset.size || 1);
    };
    const update = () => {
      const size = getSize();
      inputs.forEach(input => {
        [...input.options].forEach(option => { option.hidden = Number(option.value) > size; option.disabled = Number(option.value) > size; });
        if (Number(input.value) > size) input.value = '0';
      });
      const total = inputs.reduce((sum, input) => sum + Math.max(0, Number(input.value) || 0), 0);
      selected.textContent = String(total);
      box.textContent = String(size);
      error.hidden = true;
      return total;
    };
    root.addEventListener('input', update);
    document.addEventListener('change', () => setTimeout(update, 0));
    form.addEventListener('submit', event => {
      if (update() !== getSize()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        error.hidden = false;
        inputs[0].focus();
      }
    }, true);
    update();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rose-cupcake-flavors"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rose-cupcake-mix]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    const inputs = [...root.querySelectorAll('[data-flavor-count]')];
    const selected = root.querySelector('[data-selected-total]');
    const box = root.querySelector('[data-box-size]');
    const error = root.querySelector('[data-error]');
    const getSize = () => {
      const id = form.querySelector('input[name="id"]')?.value;
      const record = [...root.querySelectorAll('[data-variant-id]')].find(el => el.dataset.variantId === id);
      return Number(record?.dataset.size || 4);
    };
    const update = () => {
      const size = getSize();
      inputs.forEach(input => {
        [...input.options].forEach(option => { option.hidden = Number(option.value) > size; option.disabled = Number(option.value) > size; });
        if (Number(input.value) > size) input.value = '0';
      });
      const total = inputs.reduce((sum, input) => sum + Math.max(0, Number(input.value) || 0), 0);
      selected.textContent = String(total);
      box.textContent = String(size);
      error.hidden = true;
      return total;
    };
    root.addEventListener('input', update);
    document.addEventListener('change', () => setTimeout(update, 0));
    form.addEventListener('submit', event => {
      if (update() !== getSize()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        error.hidden = false;
        inputs[0].focus();
      }
    }, true);
    update();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rose-pickup-details"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rose-pickup]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    const isCake = root.dataset.cake === 'true';
    const date = root.querySelector('[data-pickup-date]');
    const time = root.querySelector('[data-pickup-time]');
    const getStoreNow = () => {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      return Object.fromEntries(parts.map(part => [part.type, part.value]));
    };
    const getEarliest = (now) => new Date(Date.UTC(Number(now.year), Number(now.month) - 1, Number(now.day) + Number(root.dataset.leadDays))).toISOString().slice(0, 10);
    date.min = getEarliest(getStoreNow());
    const check = () => {
      const now = getStoreNow();
      const today = `${now.year}-${now.month}-${now.day}`;
      const earliest = getEarliest(now);
      date.min = earliest;
      date.setCustomValidity('');
      time.setCustomValidity('');
      if (date.value) {
        const weekday = new Date(`${date.value}T12:00:00Z`).getUTCDay();
        const shortDay = weekday === 0 || weekday === 1;
        if (date.value < earliest) date.setCustomValidity('Please choose a date after the preparation period.');
        else if (shortDay && !isCake) date.setCustomValidity('Please choose Tuesday through Saturday for pickup.');
        else if (time.value) {
          const close = shortDay ? '11:00' : '18:00';
          if (time.value < '09:00' || time.value > close) time.setCustomValidity(shortDay ? 'Sunday and Monday cake pickup is available 9:00 to 11:00 AM.' : 'Pickup is available 9:00 AM to 6:00 PM.');
          else if (date.value === today && time.value <= `${now.hour}:${now.minute}`) time.setCustomValidity('Please choose a future pickup time.');
        }
      }
      return date.checkValidity() && time.checkValidity();
    };
    date.addEventListener('change', check);
    time.addEventListener('change', check);
    form.addEventListener('submit', (event) => {
      if (!check()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!date.reportValidity()) return;
        time.reportValidity();
      }
    }, true);
  });
  } catch(e) { console.error(e); }
})();

})();
